import { Component, Vue } from 'vue-property-decorator';
import { routes } from '@/router';
import { RouteType, UserDTO } from '@/models';
import NavigationItem from '@/components/common/sidebar/navigation-item/NavigationItem.vue';

@Component({
  components: {
    NavigationItem
  }
})
export default class Navigation extends Vue {
  private currentUser: UserDTO = {} as UserDTO;

  get routeRenderedInSideBar(): RouteType[] {
    this.currentUser = this.$store.getters['app/currentUser'];
    if (this.currentUser?.isAdmin) {
      return routes.filter(route => route.showItemInSideBar);
    }
    return routes.filter(route => route.showItemInSideBar && !route?.meta?.requiredAuthorization);
  }
}
